// ─────────────────────────────────────────────────────────────────────────────
//  GlobalStyles.jsx
//  Injects scoped CSS once at the top of the Challan Settlement page.
//  Handles: focus rings, hover effects, responsive breakpoints.
//  Keep style overrides here rather than in inline style objects so that
//  pseudo-selectors (:hover, :focus) and media queries are available.
// ─────────────────────────────────────────────────────────────────────────────

const CSS = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

    *, *::before, *::after { box-sizing: border-box; }

    /* ── Inputs & selects focus ring ── */
    .cs-input:focus, .cs-select:focus, .cs-textarea:focus {
        border-color: #378ADD !important;
        box-shadow: 0 0 0 3px rgba(55,138,221,0.12) !important;
    }

    /* ── Card hover lift ── */
    .cs-section:hover {
        box-shadow: 0 6px 20px rgba(15,17,23,0.09) !important;
    }

    /* ── Info card hover ── */
    .cs-icard:hover {
        border-color: #C5D8F0 !important;
        box-shadow: 0 3px 10px rgba(12,68,124,0.07) !important;
    }

    /* ── Dues row hover ── */
    .cs-dues-row:hover {
        border-color: #C5D8F0 !important;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important;
    }

    /* ── Pay mode row hover ── */
    .cs-pay-row:hover {
        border-color: #C5D8F0 !important;
        box-shadow: 0 2px 6px rgba(0,0,0,0.04) !important;
    }

    /* ── Sign box ── */
    .cs-sign-box {
        border: 1px solid #378ADD;
        border-radius: 12px;
        padding: 18px 16px;
        min-height: 116px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: #F8FAFC;
        text-align: center;
        transition: border-color 0.18s, box-shadow 0.18s;
    }
    .cs-sign-box:hover {
        border-color: #378ADD;
        box-shadow: 0 4px 12px rgba(55,138,221,0.10);
    }

    /* ── Button hovers ── */
    .cs-btn:hover       { background: #F1F5F9 !important; border-color: #9CA3AF !important; }
    .cs-btn-hold:hover  { background: #FEE2E2 !important; }
    .cs-btn-save:hover  { opacity: 0.88 !important; }

    /* ── Responsive grids ── */
    .cs-sign-control-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 14px;
        width: 100%;
    }
    .cs-sign-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 14px;
        width: 100%;
    }

    @media (max-width: 900px) {
        .cs-header-bottom  { grid-template-columns: 1fr !important; }
        .cs-pay-layout     { grid-template-columns: 1fr !important; }
        .cs-dmg-grid       { grid-template-columns: 1fr 1fr !important; }
    }

    @media (max-width: 700px) {
        .cs-sign-control-grid { grid-template-columns: 1fr; }
        .cs-cdb-grid          { grid-template-columns: 1fr !important; }
        .cs-header-top        { grid-template-columns: repeat(auto-fill, minmax(140px,1fr)) !important; }
    }

    @media (max-width: 600px) {
        .cs-sign-grid   { grid-template-columns: 1fr; }
        .cs-dmg-grid    { grid-template-columns: 1fr !important; }
        .cs-dues-row    { grid-template-columns: 1fr !important; }
        .cs-pay-row     { flex-direction: column !important; align-items: flex-start !important; }
        .cs-pm-right    { min-width: unset !important; justify-content: flex-start !important; }
        .cs-action-bar  { justify-content: stretch !important; }
        .cs-action-bar button { flex: 1 1 auto; }
    }

    @media (max-width: 480px) {
        .cs-page-inner  { padding: 12px !important; }
        .cs-section-header { padding: 11px 14px !important; }
        .cs-section-body   { padding: 14px !important; }
        .cs-kpi-value      { font-size: 15px !important; }
    }
`;

const GlobalStyles = () => <style>{CSS}</style>;

export default GlobalStyles;